import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type DebugToolbarToggleEntry = {
  label: string;
  value: string;
};

export interface IDebugBarState {
  active: boolean;
  title: string;
  toggleEntries: DebugToolbarToggleEntry[];
  selectedEntry: string;
  color: string;
}

const initialState: IDebugBarState = {
  active: false,
  title: 'Debug Toolbar',
  toggleEntries: [
    { label: 'Old page management', value: 'oldMode' },
    { label: 'New page management', value: 'newMode' },
  ],
  selectedEntry: 'none',
  color: '#17B169',
};

const debugToolbarSlice = createSlice({
  name: 'debugToolbar',
  initialState,
  reducers: {
    setSelectedEntry: (state, action: PayloadAction<string>) => {
      state.selectedEntry = action.payload;
    },
  },
});

export const { setSelectedEntry } = debugToolbarSlice.actions;

export const { reducer: debugToolbarReducer } = debugToolbarSlice;
